export const VEHICLE_FETCH_STRATEGY_OPTIONS = [
  { value: "all", text: "All" },
  { value: "active", text: "Active" },
  { value: "none", text: "None" },
];
